import 'assets/styles/mobile/avatar.scss';

const Avatar = ({ src, size = 'small', alt }) => {
  return (
    <div className={size === 'small' ? 'avatar-box' : 'u-avatar-box'}>
      <img src={src} alt={alt || 'avatar'} />
    </div>
  );
};

export default Avatar;
